import { render, staticRenderFns } from "./SpecialMaterialStatistics.vue?vue&type=template&id=3dd262e9&scoped=true"
import script from "./SpecialMaterialStatistics.vue?vue&type=script&lang=js"
export * from "./SpecialMaterialStatistics.vue?vue&type=script&lang=js"
import style0 from "./SpecialMaterialStatistics.vue?vue&type=style&index=0&id=3dd262e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd262e9",
  null
  
)

export default component.exports